'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('homepageRibbon', function() {
  return {
    restrict: 'E',
    controller: 'HomePageRibbonController as homepageRibbonCtrel',
    templateUrl: 'scripts/directives/homepage-ribbon/homepage-ribbon.prt.html'
  };
});
